import { getDataCommon } from "./common";

const getAboutAbout = () => getDataCommon("aboutabout.json");
const getAboutWork = () => getDataCommon("aboutwork.json");
const getAboutVision = () => getDataCommon("aboutvision.json");
const getAboutSecretariat = () => getDataCommon("aboutsecretariat.json");
const getAboutStructure = () => getDataCommon("aboutstructure.json");
const getAboutCEO = () => getDataCommon("aboutceo.json");
const getAboutITA = () => getDataCommon("aboutITA.json");
const getAboutAudit = () => getDataCommon("aboutaudit.json");
const getAboutExecutive = () => getDataCommon("aboutexecutive.json");
const getAboutDirector = () => getDataCommon("aboutdirector.json");

export {
  getAboutAbout,
  getAboutWork,
  getAboutVision,
  getAboutSecretariat,
  getAboutStructure,
  getAboutCEO,
  getAboutITA,
  getAboutAudit,
  getAboutExecutive,
  getAboutDirector,
};
